import React, { useState } from 'react';
import axios from 'axios';



function EmailMarketing() {
  const [excelFile, setExcelFile] = useState(null);
  const [imageFiles, setImageFiles] = useState([]);
  const [logoFile, setLogoFile] = useState(null);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleExcelFileChange = (e) => {
    setExcelFile(e.target.files[0]);
  };

  const handleImageFilesChange = (e) => {
    setImageFiles(Array.from(e.target.files));
  };

  const handleLogoFileChange = (e) => {
    setLogoFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!excelFile) {
      setMessage('Please select an Excel file.');
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append('excelFile', excelFile);
    // Append all selected image files to the form data
    imageFiles.forEach(file => {
      formData.append('images', file);
    });
    // Append logo file if selected
    if (logoFile) {
      formData.append('logo', logoFile);
    }

    try {
      const apiUrl = process.env.REACT_APP_BACKEND_URL;
      console.log("API URL:", apiUrl);
      const response = await axios.post(`${apiUrl}/api/email-marketing/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setMessage(response.data.message);
    } catch (error) {
      console.error('Error uploading files:', error);
      setMessage(error.response ? error.response.data : 'Server error. Please try again.');
    } finally {
      setLoading(false);
      setExcelFile(null);
      setImageFiles([]);
      setLogoFile(null);
      document.getElementById('excelFileInput').value = null;
      document.getElementById('imageFileInput').value = null;
      document.getElementById('logoFileInput').value = null;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center py-8 px-2 relative">
      {/* Sample Excel Download Button */}
      <a 
        href="./ExcelForMailer.xlsx"
        download
        className="absolute top-8 right-8 z-10 bg-green-600 hover:bg-green-700 text-white font-semibold px-4 py-2 rounded-lg shadow-md transition-all duration-200"
        style={{textDecoration: 'none'}}
      >
        Sample Excel for Test
      </a>
      <div className="w-full max-w-lg bg-white shadow-xl rounded-2xl p-8 border border-gray-100">
        <h1 className="text-3xl font-bold text-indigo-700 mb-2 text-center">Send Emails from Excel</h1>
        <p className="text-gray-600 mb-6 text-center">Upload an Excel file with <span className="font-semibold text-indigo-600">'email'</span> and <span className="font-semibold text-indigo-600">'image'</span> columns, then upload the images below.</p>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Select Excel File</label>
            <input
              type="file"
              id="excelFileInput"
              accept=".xlsx, .xls"
              onChange={handleExcelFileChange}
              className="block w-full text-sm text-gray-700 border border-gray-300 rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-400 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Select Images</label>
            <input
              type="file"
              id="imageFileInput"
              multiple
              accept="image/*"
              onChange={handleImageFilesChange}
              className="block w-full text-sm text-gray-700 border border-gray-300 rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-400 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Select Logo Image (optional)</label>
            <input
              type="file"
              id="logoFileInput"
              accept="image/*"
              onChange={handleLogoFileChange}
              className="block w-full text-sm text-gray-700 border border-gray-300 rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-400 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`w-full py-3 px-6 rounded-lg font-semibold text-white transition-all duration-200 shadow-md ${loading ? 'bg-indigo-300 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'}`}
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                </svg>
                Sending...
              </span>
            ) : 'Send Emails'}
          </button>
        </form>
        {message && (
          <div className={`mt-6 text-center px-4 py-3 rounded-lg font-medium ${message.toLowerCase().includes('success') ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
}

export default EmailMarketing;